/* Barre d'achat collante — hy.
   Réécrite le 21/09/2026 : l'ancienne version ne se montrait que pendant un
   défilement vers le bas (« y >= dernier - 4 ») et mettait à jour « dernier »
   depuis les observateurs, donc elle clignotait au moindre micro-défilement et
   disparaissait dès qu'on remontait de deux pixels. Elle se déclenchait aussi
   sur un seuil en pixels arbitraire (600), qui n'a rien à voir avec l'endroit
   où le vrai bouton d'achat se trouve selon la largeur de l'écran.

   Règle : la barre apparaît quand le vrai bouton « Ajouter au panier » est
   sorti par le haut, elle reste tant qu'on est plus bas, et elle s'efface
   quand le pied de page arrive. Aucune notion de direction. */
(function () {
  var BARRE = document.querySelector('[data-hy-collant]');
  if (!BARRE) return;
  var SEUIL = parseInt(BARRE.getAttribute('data-seuil'), 10) || 600;
  var bouton = BARRE.querySelector('[data-hy-collant-achat]');
  function vraiBouton() {
    return document.querySelector('.product-form__submit, button[name="add"]');
  }
  var vrai = vraiBouton();

  /* Le pied de page est le dernier bloc : la barre s'efface dès qu'il arrive. */
  var piedVisible = false;
  var pied = document.querySelector('.hy-pied');
  if (pied && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { piedVisible = e[0].isIntersecting; peindre(); })
      .observe(pied);
  }

  /* Hystérésis de 24 px à l'apparition, 8 px à la disparition. Entre les deux
     on ne change rien : c'est ce qui empêche le clignotement à la frontière. */
  var passe = false;
  var dejaMontre = false;   /* état affiché : au chargement la barre est cachée (aria-hidden + inert dans le HTML) */
  function peindre() {
    var v = vraiBouton() || vrai;
    if (v) vrai = v;
    if (vrai) {
      var bas = vrai.getBoundingClientRect().bottom;
      if (!passe && bas < -24) passe = true;
      else if (passe && bas > 8) passe = false;
    } else {
      passe = (window.scrollY || document.documentElement.scrollTop) > SEUIL;
    }
    var montre = passe && !piedVisible;
    /* On n'écrit que si l'état change : réécrire les attributs à chaque contrôle obligeait le téléphone à
       recalculer la mise en page au contrôle suivant (PageSpeed, « ajustement forcé », 05/10/2026). */
    if (montre === dejaMontre) return;
    dejaMontre = montre;
    BARRE.classList.toggle('est-visible', montre);
    BARRE.setAttribute('aria-hidden', montre ? 'false' : 'true');
    /* cachée = inactive : son bouton ne doit pas être atteignable au clavier ni par un lecteur d'écran */
    if (montre) BARRE.removeAttribute('inert'); else BARRE.setAttribute('inert', '');
  }

  /* Cadence au chronomètre, pas au requestAnimationFrame : dans un onglet en
     arrière-plan le navigateur ne déclenche plus jamais de frame, l'ancien
     « enAttente » restait à true et la barre se figeait définitivement — visible
     alors qu'on est revenu en haut, ou l'inverse. Les minuteries, elles,
     continuent de tourner. */
  var enAttente = false, dernierPeint = 0;
  function surDefilement() {
    var t = Date.now();
    if (t - dernierPeint > 60) { dernierPeint = t; peindre(); return; }
    if (enAttente) return;
    enAttente = true;
    setTimeout(function () { enAttente = false; dernierPeint = Date.now(); peindre(); }, 60);
  }
  window.addEventListener('scroll', surDefilement, { passive: true });
  window.addEventListener('resize', surDefilement, { passive: true });
  document.addEventListener('visibilitychange', peindre);
  /* La colonne de droite glisse à l'arrivée (animation Dawn) : le bouton bouge
     encore pendant une demi-seconde, on repeint une fois que c'est fini. */
  window.addEventListener('load', peindre);
  setTimeout(peindre, 700);
  peindre();

  /* Le bouton de la barre clique le vrai bouton : toute la mécanique
     (offre quantité, tiroir panier) reste au même endroit. */
  if (bouton) bouton.addEventListener('click', function () {
    var b = vraiBouton();
    if (!b) return;
    b.scrollIntoView({ block: 'center', behavior: 'auto' });
    b.click();
  });
})();

/* La barre affiche l'offre COCHÉE (04/10) : elle ajoute au panier l'offre choisie dans le bloc « Achetez en lot »
   (par défaut le 2+1), elle ne doit donc pas afficher le prix d'un seul ensemble. Nom, prix et prix barré sont
   recopiés de la carte cochée : ils restent ceux de l'éditeur et de la devise du client. */
(function () {
  var BARRE = document.querySelector('[data-hy-collant]');
  if (!BARRE) return;
  function synchro() {
    var r = document.querySelector('input[name="cz-lot"]:checked');
    var choix = r && r.closest('.cz-lot__choix');
    if (!choix) return;
    var prix = choix.querySelector('.cz-lot__prix'), barre = choix.querySelector('.cz-lot__barre'), nom = choix.querySelector('.cz-lot__nom');
    var cPrix = BARRE.querySelector('.hy-collant__prix'), cNom = BARRE.querySelector('.hy-collant__nom');
    if (prix && cPrix && prix.textContent.trim()) {
      cPrix.textContent = prix.textContent.trim();
      if (barre && barre.textContent.trim()) {
        var s = document.createElement('span'); s.className = 'hy-collant__barre'; s.textContent = barre.textContent.trim();
        cPrix.appendChild(s);
      }
    }
    if (nom && cNom && nom.textContent.trim()) cNom.textContent = nom.textContent.trim();
  }
  document.addEventListener('change', function (e) { if (e.target && e.target.name === 'cz-lot') setTimeout(synchro, 0); });
  new MutationObserver(function () { if (BARRE.classList.contains('est-visible')) synchro(); })
    .observe(BARRE, { attributes: true, attributeFilter: ['class'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(synchro, 400); });
  else setTimeout(synchro, 400);
})();
